import { render, staticRenderFns } from "./PartnerSiteWPModal.vue?vue&type=template&id=0b6d37d4&"
import script from "./PartnerSiteWPModal.vue?vue&type=script&lang=js&"
export * from "./PartnerSiteWPModal.vue?vue&type=script&lang=js&"
import style0 from "./PartnerSiteWPModal.vue?vue&type=style&index=0&id=0b6d37d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports